import React from 'react';
import { Row, Col, Card as RBCard } from "react-bootstrap";
import { Box, Typography, Avatar, Button } from "@mui/material";

const DashboardCards = ({ cards }) => {
    return (
        <Row className="mt-3" xs={1} sm={2} lg={4}>
            {cards.map((card) => (
                <Col className="mb-3" key={card.id}>
                    <RBCard className="shadow-sm border-0 rounded-4" style={{ height: "100%" }}>
                        <RBCard.Body style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="flex-start"
                            >
                                <Typography variant="body3" color="gray" fontWeight={500}>
                                    {card.title}
                                </Typography>

                                <Avatar sx={{ bgcolor: "#E0E7FF" }}>
                                    {card.icon}
                                </Avatar>
                            </Box>

                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                mt={4}
                                gap={2}
                            >
                                {card.buttons.map((btn, idx) => (
                                    <Button
                                        key={idx}
                                        fullWidth
                                        variant="outlined"
                                        className={btn.className}
                                        onClick={btn.onClick}
                                    >
                                        {btn.icon && (
                                            <img src={btn.icon} alt="Icon" style={{ marginRight: '8px' }} />
                                        )}
                                        {btn.label}
                                    </Button>
                                ))}
                            </Box>
                        </RBCard.Body>
                    </RBCard>
                </Col>
            ))}
        </Row>
    );
};

export default DashboardCards;
